import { BodyAtFaultQueryResponseType } from '@/common/queries/selections/bodyAtFault/bodyAtFaultQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const bodyAtFaultFunction = (): Promise<
  BodyAtFaultQueryResponseType[]
> => {
  return fetchApi.get('selection_item/body_at_fault/wop_list/');
};
